import { VStack } from 'tio-reimagined/components/layout';
import NewTypeFourApp from 'tio-employee/components/tas/applications/new/type-four';
import type TasApplicationModel from 'tio-data/models/tas-application';
import type TASProgramInstanceModel from 'tio-data/models/tas-program-instance';
import type { TOC } from '@ember/component/template-only';

export interface S {
  Args: {
    model: {
      application: TasApplicationModel;
      programInstance: TASProgramInstanceModel;
    };
  };
}

const tmpl: TOC<S> = <template>
  <VStack>
    <NewTypeFourApp @model={{@model}} />
  </VStack>
</template>;

export default tmpl;
